// extracted by mini-css-extract-plugin
export var author = "Author-module--author--2kT-Q";
export var bio = "Author-module--bio--2YX8-";
export var github = "Author-module--github--1Ulhd";